import { useAuthStore } from '@/store/auth';
import { useContextStore } from '@/store/context';
import { useMagasinStore } from '@/store/magasin';
import { TrackJS } from 'trackjs';

export default defineNuxtPlugin(({ $pinia }) => {
  const contextStore = useContextStore($pinia);
  const authStore = useAuthStore($pinia);
  const magasinStore = useMagasinStore($pinia);

  const config = useRuntimeConfig();
  if (config.public.IS_DEV) {
    return;
  }
  TrackJS.install({
    token: config.public.TRACKJS_TOKEN,
    application: config.public.TRACKJS_APPLICATION,
    userId: contextStore.uuid,
    onError: (payload, error) => {
      payload.metadata.push(
        {
          key: "layout",
          value: contextStore.layout
        },
        {
          key: "version",
          value: config.public.VERSION
        },
        {
          key: "isLogged",
          value: authStore.isLogged
        },
        {
          key: "magasin",
          value: magasinStore.id
        }
      );
      return true;
    }
    // for more configuration options, see https://docs.trackjs.com
  });  
});
